import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MagnifyingGlass } from '@phosphor-icons/react';

export const HistoryFilters = ({
  searchTerm, onSearch,
  dateFrom, onDateFrom,
  dateTo, onDateTo,
  status, onStatus, statusOptions
}) => {
  return (
    <div className="bg-white border rounded p-3 mb-3 flex flex-wrap gap-3 items-end">
      <div className="flex-1 min-w-[220px] relative">
        <Label className="text-xs">Buscar</Label>
        <div className="relative">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input
            value={searchTerm}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Folio, motivo, producto, persona…"
            className="pl-9"
            data-testid="history-search"
          />
        </div>
      </div>
      <div>
        <Label className="text-xs">Desde</Label>
        <Input type="date" value={dateFrom} onChange={(e) => onDateFrom(e.target.value)} data-testid="history-date-from" />
      </div>
      <div>
        <Label className="text-xs">Hasta</Label>
        <Input type="date" value={dateTo} onChange={(e) => onDateTo(e.target.value)} data-testid="history-date-to" />
      </div>
      {statusOptions && (
        <div className="min-w-[160px]">
          <Label className="text-xs">Estado</Label>
          <Select value={status} onValueChange={onStatus}>
            <SelectTrigger data-testid="history-status"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              {statusOptions.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};
